import { TextColors } from "@abel-technologies-as/components";
import styled from "styled-components";

const Ul = styled.ul`
	list-style: disc;
	padding-left: 20px;
	margin-bottom: 24px;
`;

const Li = styled.li`
	&::marker {
		color: ${TextColors.Tertiary};
	}
`;

const TableWrapper = styled.div`
	max-width: 640px;
	margin-bottom: 32px;
`;

export { Ul, Li, TableWrapper };
